import {Injectable} from '@angular/core';
import {PressVideoState, Store as PressVideoStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {PressVideo} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {PressVideoQuery} from './query';
import {FormService} from "../../../components/service/form.service";

@Injectable({ providedIn: 'root' })
export class PressVideoService extends EntityService<PressVideoStore, PressVideoState> {

  items$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new PressVideo(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('pressVideo.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('pressVideo.title'),
        inputType: 'text',
        name: 'title',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('pressVideo.url'),
        inputType: 'text',
        name: 'url',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
      FieldConfig.create({
        type: 'image',
        label: this.translocoService.selectTranslate('pressVideo.image'),
        name: 'image',
        listed: false,
        validations: this.formService.getValidations(['requiredImage'])
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: PressVideoQuery,
    private formService: FormService,
    protected store: PressVideoStore) {
    super(store, PressVideo);
  }

  get resourceName(): string {
    return 'content/press-video';
  }

}
